
import { computed, defineComponent, PropType } from 'vue';
import CMSLinkHandler from '../../helpers/CMSLinkHandler.vue';
import { CallToActionTileModel } from '@/types/B2BcontentServerContract';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';

export default defineComponent({
    name: 'BaseLayoutLetsBeFriendsAndLookBook',
    components: { MediaHandler, CMSLinkHandler },
    props: {
        content: {
            type: Object as PropType<CallToActionTileModel>,
            required: true,
        },
    },
    setup(props) {
        const aspectRatio = { xs: 2 / 3, sm: 10 / 9, md: 16 / 9, default: 40 / 27 };

        const textTileContentBlock = computed(() => {
            return props.content.tiles[0].model;
        });

        const mediaTileContentBlock = computed(() => {
            return props.content.tiles[1].model;
        });

        const flexOrderClass = computed(() => {
            return props.content.flipImageAndText ? '' : 'md:flex-row-reverse';
        });

        const absolutePositionClasses = computed(() => {
            return props.content.flipImageAndText ? 'md:flex md:flex-col md:items-end md:text-right lg:right-0 lg:mr-60' : 'lg:left-0 lg:ml-60';
        });

        return {
            aspectRatio,
            textTileContentBlock,
            mediaTileContentBlock,
            flexOrderClass,
            absolutePositionClasses,
        };
    },
});
